import first from "lodash/first";
import last from "lodash/last";

import { Request, Trip } from "types";
import { tripStartEndDateTimeParser } from "pages/requests/utils/calculateTripEndDateTime";
import {
  formatStopLocation,
  getPickupVariantText,
  formatLuggageInfo,
  formatStopNote,
  formatPassengerDisplay,
  formatInnerStops,
} from "./tripFormatters";

export const getTripDetailsText = (
  request: Request,
  trip: Trip,
  isFarmee: boolean
) => {
  const pickUpStop = first(trip.stops);
  const dropOffStop = last(trip.stops);
  const route = first(trip.routes);

  // Format basic trip info
  const tripNumber = `${request.orderNumber}-${trip.tripNumber}`;
  const pickUpDateTime = tripStartEndDateTimeParser({
    startDateTime: pickUpStop.dateTime,
    endDateTime: dropOffStop.dateTime,
    excludeNewLine: true,
  });
  const modifiedStops = trip.stops.map(formatStopLocation);
  const innerStops = formatInnerStops(trip.stops);
  const pickUpStopVariant = getPickupVariantText(pickUpStop.pickUpVariant);
  const pickupNote = formatStopNote(pickUpStop.note, "Pick-Up Stop Notes");
  const dropoffNote = formatStopNote(dropOffStop.note, "Drop-Off Stop Notes");
  const luggageString = formatLuggageInfo(route);
  const passengerDisplay = formatPassengerDisplay(trip, isFarmee);

  return `Trip Number: ${tripNumber}
Pick-Up Date/Time: ${pickUpDateTime}
Passenger: ${passengerDisplay}
[PU]: ${first(modifiedStops)}${
    pickUpStopVariant ? ` (${pickUpStopVariant})` : ""
  }${pickupNote}${innerStops}
[DO]: ${last(modifiedStops)}${dropoffNote}
Trip Notes: ${trip.note || "N/A"}
Driver Notes: ${route?.driverNote || "N/A"}
Luggage: ${luggageString}`;
};


